import React from "react";
import PageHeader from "../pageHeader/PageHeader";

interface PageLayoutProps {
  title?: string;
  /** Extra class on the outer page wrapper (e.g. contact-container). */
  className?: string;
  /** Extra class on the center column (e.g. produits). */
  contentClassName?: string;
  children?: React.ReactNode;
  /** Rendered after the main grid (e.g. map, carousel). */
  after?: React.ReactNode;
}

const PageLayout: React.FC<PageLayoutProps> = ({
  title,
  className = "",
  contentClassName = "",
  children,
  after,
}) => {
  return (
    <div className={`${className} page-container`.trim()}>
      <PageHeader title={title} />
      <div className="main-container">
        <div className="page-content">
          <div className="spacer col-left" />
          <div className={`col-center ${contentClassName}`.trim()}>
            {children}
          </div>
        </div>
      </div>
      {after}
    </div>
  );
};

export default PageLayout;
